import { ITopProductProps } from '../../../../topProduct.models';
import * as S from './topNavigationLiteHero.style';
import { DetailsChecklist } from '../DetailsChecklist/detailsChecklist';
import { ImageAtoms, Price, Svg } from '@vfit/shared/atoms';
import { IGradientImage, PriceVariant } from '@vfit/shared/models';
import ProductOptions from '../../../../../ProductCardLite/components/ProductOptions/productOptions';
import { useState } from 'react';
import { VfModal } from '@vfit/shared/components';
import { purify } from '@vfit/shared/themes';
import { TopNavigationLitePopup } from './components/TopNavigationLitePopup/topNavigationLitePopup';
import { goBackFromUrl } from '../../../../topProduct.utils';
import { useQueryClient } from 'react-query';
import { IGlobalPromoCMS } from '@vfit/consumer/data-access';

export const TopNavigationLiteHero = ({ product }: ITopProductProps) => {
  const queryClient = useQueryClient();
  const { globalpromo } = (queryClient?.getQueryData('getGlobalPromo') || {}) as IGlobalPromoCMS;
  const {
    title,
    price,
    priceLiteLabel,
    originalPrice,
    recurrence,
    description,
    descriptionPdp,
    image,
    imageMobile,
    backLabel,
    backUrl,
    inflactionPdp,
    priceVariant,
    pdpLiteOptionDetails,
    pdpLiteCtaPopup,
    pdpLiteMarketingTagLabel: marketingTagLabel,
    pdpLiteMarketingTagColor: marketingTagColor,
    pdpLiteMarketingTagBackground: marketingTagBg,
    pdpLiteMarketingTagSecondaryLabel: secondaryMarketingTagLabel,
    pdpLiteMarketingTagSecondaryColor: secondaryMarketingTagColor,
    pdpLiteMarketingTagSecondaryBackground: secondaryMarketingTagBg,
    pdpLiteOfferClaimCard,
    pdpLiteOfferNameCard,
    image5G,
    isGlobalPromoActive,
  } = product;
  const [pDescription, pDescriptionPdp] = purify([description || '', descriptionPdp || '']);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  return (
    <S.BannerContainer>
      <S.DivImgContainer>
        <ImageAtoms
          gradient={IGradientImage.GRADIENT_TOP_LEFT}
          nameCard="slideProduct"
          image={image}
          imageMobile={imageMobile}
        />
      </S.DivImgContainer>
      <S.MainSection>
        <S.Breadcrumb
          onClick={() => {
            if (backUrl) window.location.href = backUrl || '';
            else goBackFromUrl();
          }}
        >
          <Svg name={'chevronLeft'} width={16} height={16} color={'#fff'} />
          <S.GoBackLabel>{backLabel}</S.GoBackLabel>
        </S.Breadcrumb>
        <S.OfferSection>
          <S.TagContainer>
            {(!isGlobalPromoActive || !globalpromo?.marketingTagLabel) && marketingTagLabel && (
              <S.Tag bgColor={marketingTagBg} color={marketingTagColor}>
                <span>{marketingTagLabel}</span>
              </S.Tag>
            )}
            {isGlobalPromoActive && globalpromo?.marketingTagLabel && (
              <S.Tag
                bgColor={globalpromo?.marketingTagBackground}
                color={globalpromo?.marketingTagColor}
              >
                <span>{globalpromo.marketingTagLabel}</span>
              </S.Tag>
            )}
            {secondaryMarketingTagLabel && (
              <S.Tag bgColor={secondaryMarketingTagBg} color={secondaryMarketingTagColor}>
                <span>{secondaryMarketingTagLabel}</span>
              </S.Tag>
            )}
          </S.TagContainer>
          <S.TitleContainer>
            {pdpLiteOfferClaimCard ? (
              <S.Title
                dangerouslySetInnerHTML={{
                  __html: pdpLiteOfferClaimCard || '',
                }}
              />
            ) : (
              <S.Title>{title}</S.Title>
            )}
            {pdpLiteCtaPopup && (
              <S.SubtitleCta onClick={() => setIsOpenPopup(true)}>{pdpLiteCtaPopup}</S.SubtitleCta>
            )}
          </S.TitleContainer>
        </S.OfferSection>
      </S.MainSection>

      <S.CardDetails>
        <S.OfferDetails pdpLiteOfferNameCard={pdpLiteOfferNameCard}>
          {image5G?.visible && image5G?.imageDesktop && (
            <div className="image-atoms-top-right">
              <ImageAtoms nameCard="topImage" image={image5G?.imageDesktop || ''} width="40px" />
            </div>
          )}
          <div>
            {pdpLiteOfferNameCard && (
              <S.offerNameCardTitle dangerouslySetInnerHTML={{ __html: pdpLiteOfferNameCard }} />
            )}
            <Price
              label={priceLiteLabel || ''}
              amount={price}
              oldAmount={originalPrice}
              recurrence={recurrence}
              variant={product?.isLandingClub ? 'freeAmount' : (priceVariant as PriceVariant)}
              detail={product?.isLandingClub ? product?.subprice : ''}
              description={product?.isLandingClub ? product?.descriptionRecurring : ''}
            />
            {(pDescriptionPdp || pDescription) && (
              <div
                className="productDescription"
                dangerouslySetInnerHTML={{ __html: pDescriptionPdp || pDescription || '' }}
              />
            )}
          </div>
          <ProductOptions inflactions={inflactionPdp} />
          {pdpLiteOptionDetails && (
            <S.DetailsList>
              <DetailsChecklist checkList={pdpLiteOptionDetails} />
            </S.DetailsList>
          )}
        </S.OfferDetails>
      </S.CardDetails>
      <VfModal isOpen={isOpenPopup} handleClose={() => setIsOpenPopup(false)}>
        <TopNavigationLitePopup product={product} />
      </VfModal>
    </S.BannerContainer>
  );
};

